module.exports = __webpack_public_path__ + "img/carsnitch-dark-blue.e514fcc1.svg";